// removed by extract-text-webpack-plugin
module.exports = {"button":"button__20xhZ","rippleWrapper":"rippleWrapper__DS_V0","squared":"squared__3AZhT","icon":"icon__IB0dR","solid":"solid__1H2lv","raised":"raised__r4lU5 button__20xhZ squared__3AZhT solid__1H2lv","flat":"flat__1r1Pt button__20xhZ squared__3AZhT","floating":"floating__2uGP3 button__20xhZ solid__1H2lv","mini":"mini__2XlsV","toggle":"toggle__fYymG button__20xhZ","primary":"primary__2kO4n","accent":"accent__2oX2A","neutral":"neutral__1ynBh","inverse":"inverse__20Nnw"};


//////////////////
// WEBPACK FOOTER
// ../~/react-toolbox/lib/button/theme.css
// module id = ehFq
// module chunks = 6